<style lang="less" scoped>
  .query-title-div {
    width: 90px !important;
  }
  .lang-width {
    width: 450px !important;
  }
  .list-content-div {
    margin-top: 16px;
  }
  
  .decOps_form{
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    border: 1px solid #bb87f3;
    border-radius: 16px;
    margin-bottom: 24px;
    
    display: flex;
    flex-direction: column;
  }
  
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb
          :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">运维备注</div>
      <ZD-list-querys> </ZD-list-querys>
      
      <!-- 提交表达信息 -->
      <div class="decOps_form">
        <div class="list-query-child-div flex" style="margin-bottom: 20px;">
          <div class="query-title-div">充电桩编号：</div>
          <div>{{ queryInfo.pileCode }}</div>
        </div>
        <div class="list-query-child-div flex" style="margin-bottom: 20px;">
          <div class="query-title-div">运维状态：</div>
          <div class="query-inputs-div flex-1">
            <el-select size="small" v-model="queryInfo.status" clearable style="width: 64%;">
              <el-option label="正常运营" value="03"></el-option>
              <el-option label="下电" value="04"></el-option>
              <el-option label="拆除待注销" value="05"></el-option>
              <el-option label="拆除已注销" value="06"></el-option>
            </el-select>
          </div>
        </div>
        <div class="list-query-child-div flex" style="margin-bottom: 20px;">
          <div class="query-title-div">备注说明：</div>
          <div class="query-inputs-div flex-1">
            <el-input type="textarea" size="small" v-model="queryInfo.remark" style="width: 64%;"
                      placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="flex" style="width: 100%; justify-content: flex-end;">
          <button class="common-bg-button" @click="handleSubmit()">提 交</button>
        </div>
      </div>
      
      <div class="page-action-btns flex margin-tb-10">
        <button class="common-bg-button" @click="addRemarkFun()">编 辑</button>
        <button class="common-bg-button" @click="handleDelete()">删 除</button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
            :tableColumns="pageConfig.operationColumns"
            :operates="operates"
            :tableData="tableData"
            :tableConfig="pageConfig.tableConfig"
            :selections="selections"
            v-on:updateSelections="
            (sels) => {
              selections = sels
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="getFormInfo"
        ></ZD-pagination>
      </div>
      <el-dialog title="修改运维备注" :visible.sync="dialogFormVisible">
        <el-form :model="repairForm">
          <el-form-item label="运维状态">
            <el-select size="small" v-model="repairForm.status" style="width: 100%;">
              <el-option label="正常运营" value="03"></el-option>
              <el-option label="下电" value="04"></el-option>
              <el-option label="拆除待注销" value="05"></el-option>
              <el-option label="拆除已注销" value="06"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运维备注">
            <el-input type="textarea" size="small" v-model="repairForm.remark" style="width: 100%;"
                      placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogSubmit()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
    import pageConfig from './page-config'
    export default {
        data() {
            return {
                pageConfig,
                pagination: pageConfig.pagination,
                // 默认值设置
                detailForm: {},
                queryInfo: {
                    pileCode: '',
                    status: '',
                    statusName: '',
                    remark: '',
                },
                repairForm: {},
                operates: {
                    width: 220,
                    fixed: 'right',
                    list: [],
                }, // 列操作按钮
                tableData: [], // 表格数据
                selections: [], // 表格选项
                dialogFormVisible: false,
            }
        },
        methods: {
            // 获取表单信息
            getFormInfo() {
                let _ = this
                let url =_.$A.pile.getDevOps;
                _.$U.showLoading(_);
                _.$H.post(_, url,{pileCode: _.queryInfo.pileCode}).then(res=>{
                    _.tableData = res.data.data.content;
                    _.$U.hideLoading(_);
                })
            },
            // 新增运维信息
            handleSubmit(){
                let _ = this;
                let url =_.$A.pile.addDevOps;
                if(!_.queryInfo.status){
                    return _.$U.error('请选择运维状态');
                }
                if(_.queryInfo.status === '03') _.queryInfo.statusName = '正常运营';
                if(_.queryInfo.status === '04') _.queryInfo.statusName = '下电';
                if(_.queryInfo.status === '05') _.queryInfo.statusName = '拆除待注销';
                if(_.queryInfo.status === '06') _.queryInfo.statusName = '拆除已注销';
                _.$H.post(_, url,_.queryInfo).then(res => {
                    if(res.data.status === 200){
                        _.queryInfo = {
                            pileCode: _.$store.state.editId,
                            status: '',
                            statusName: '',
                            remark: '',
                        }
                        _.$U.success('添加成功');
                        setTimeout(() => {
                            _.getFormInfo();
                        }, 1000)
                    }
                })
            },
            // 删除运维
            handleDelete(){
                let _ = this;
                if (_.checkSelectOne()) {
                    let url = _.$A.pile.delDevOps;
                    _.$H.post(_, url, {historyNo: _.selections[0].historyNo}).then(res => {
                        _.$U.success('删除成功');
                        setTimeout(() => {
                            _.getFormInfo();
                        }, 1000)
                    })
                }
            },
            //选择表格
            checkSelectOne() {
                if (this.selections.length < 1) {
                    this.$U.error('请选择需要操作的对象')
                    return false
                }
                if (this.selections.length > 1) {
                    this.$U.error('只能选择一个操作的对象')
                    return false
                }
                return true
            },
            //点击备注
            addRemarkFun() {
                if (this.checkSelectOne()) {
                    let _ = this
                    this.dialogFormVisible = true;
                    _.repairForm = _.selections[0];
                }
            },
            // 编辑提交表单
            dialogSubmit() {
                let _ = this;
                if(_.repairForm.status === '03') _.repairForm.statusName = '正常运营';
                if(_.repairForm.status === '04') _.repairForm.statusName = '下电';
                if(_.repairForm.status === '05') _.repairForm.statusName = '拆除待注销';
                if(_.repairForm.status === '06') _.repairForm.statusName = '拆除已注销';
                _.$H.post(_, _.$A.pile.editDevOps, _.repairForm).then((res) => {
                    _.$U.success('编辑成功');
                    this.dialogFormVisible = false
                    _.getFormInfo()
                })
            },
        },
        mounted() {
            this.queryInfo.pileCode = this.$store.state.editId;
            this.getFormInfo();
        },
    }
</script>
